export const THUMBNAIL_MAX_AUTHORIZED_SIZE = 5 * Math.pow(1024, 2); // Max custom thumbnail size in Bytes
//# sourceMappingURL=widget.js.map